<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10">
                        <div class="modal-container" @click.stop>

                            <div class="modal-header row" style="justify-content: flex-end;">
                                <div class="col">
                                    <button type="button" class="close" @click="$emit('closeModal')">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>

                            <div class="modal-body">

                                <h2 class="text-center">QR Code Details</h2>
                                
                                <div class="row">
                                    <div class="col-md-6" v-if="data.detail">
                                        <div class="text-center">
                                            <div class="info--image">
                                                <img :src="fetchHdImageIfPossible" style="height: 250px;"/>
                                                <div
                                                    v-if="data.detail.is_expired == 1"
                                                    class="info--expired"
                                                    style="color: orange; background-color: white; padding: 5px 10px; border-radius: 15px; opacity: 0.95;"
                                                >
                                                    <i class="fas fa-exclamation-triangle fa-4x"></i>
                                                    <p style="font-weight: bold; margin: 0;">Expired!</p>
                                                </div>
                                            </div>

                                            <div class="innerBox" style="position: relative;">
                                                <div class="info--status" :class="{'orange' : data.detail.status == 0, 'green' : data.detail.status == 1, 'red' : data.detail.status == 2}">
                                                    <i class="fas fa-4x" :class="{'fa-times-circle' : data.detail.status == 0, 'fa-badge-check' : data.detail.status == 1, 'fa-ban' : data.detail.status == 2}"></i>
                                                    <p style="font-weight: bold;">{{ data.detail.status == 0 ? 'Unverified' : data.detail.status == 1 ? 'Verified' : data.detail.status == 2 ? 'Deactivated' : 'N/A' }}</p>
                                                </div>

                                                <p class="sub-title">Detail Information</p>

                                                <p class="info--key">QR Code</p>
                                                <p class="info--value">{{ data.detail.qrcode ? data.detail.qrcode : 'N/A' }}</p>

                                                <p class="info--key">Serial Number</p>
                                                <p class="info--value">{{ data.detail.serial ? data.detail.serial : 'N/A' }}</p>

                                                <div style="display: flex; flex-direction: row; justify-content: space-between;">
                                                    <div>
                                                        <p class="info--key">Status</p>
                                                        <p
                                                            class="info--value font-weight-bold"
                                                            :class="{'orange' : data.detail.status == 0, 'green' : data.detail.status == 1, 'red' : data.detail.status == 2}"
                                                        >{{ data.detail.status == 0 ? 'Unverified' : data.detail.status == 1 ? 'Verified' : data.detail.status == 2 ? 'Deactivated' : 'N/A'}}</p>
                                                    </div>
                                                    <div>
                                                        <p class="info--key text-right">Is Expired</p>
                                                        <p
                                                            class="info--value text-right"
                                                            :class="{'orange' : data.detail.is_expired == 1}"
                                                        >{{ data.detail.is_expired == 0 ? 'No' : data.detail.is_expired == 1 ? 'Yes' : 'N/A' }}</p>
                                                    </div>
                                                </div>

                                                <p class="info--key">Part Number</p>
                                                <p class="info--value">{{ data.detail.part_no ? data.detail.part_no : 'N/A' }}</p>

                                                <div style="display: flex; flex-direction: row; justify-content: space-between;">
                                                    <div>
                                                        <p class="info--key">Type</p>
                                                        <p class="info--value">{{ data.detail.type ? data.detail.type : 'N/A' }}</p>
                                                    </div>
                                                    <div>
                                                        <p class="info--key text-right">Volume</p>
                                                        <p class="info--value text-right">{{ data.detail.volume ? (parseInt(data.detail.volume))/1000 + ' Liter' : 'N/A' }}</p>
                                                    </div>
                                                </div>

                                                <p class="info--key">Description</p>
                                                <p class="info--value" style="font-size: 14px; color: #616161;">{{ data.detail.description ? data.detail.description : 'N/A' }}</p>
                                            </div>

                                            <div class="innerBox mt-4">
                                                <p class="sub-title">Label, Bottle, & Oil Maker</p>

                                                <div style="display: flex; flex-direction: row; justify-content: space-between;">
                                                    <div>
                                                        <p class="info--key">Label Maker</p>
                                                        <p class="info--value">{{ data.detail.label_maker ? data.detail.label_maker : 'N/A' }}</p>
                                                    </div>
                                                    <div>
                                                        <p class="info--key text-right">Label Active Date</p>
                                                        <p class="info--value text-right">{{ data.detail.label_active_date ? moment(data.detail.label_active_date).format("DD MMM YYYY HH:mm:ss") : 'N/A' }}</p>
                                                    </div>
                                                </div>

                                                <div style="display: flex; flex-direction: row; justify-content: space-between;">
                                                    <div>
                                                        <p class="info--key">Oil Maker</p>
                                                        <p class="info--value">{{ data.detail.oil_maker ? data.detail.oil_maker : 'N/A' }}</p>
                                                    </div>
                                                    <div>
                                                        <p class="info--key text-right">Oil Active Date</p>
                                                        <p class="info--value text-right">{{ data.detail.oil_active_date ? moment(data.detail.oil_active_date).format("DD MMM YYYY HH:mm:ss") : 'N/A' }}</p>
                                                    </div>
                                                </div>

                                                <div style="display: flex; flex-direction: row; justify-content: space-between;">
                                                    <div>
                                                        <p class="info--key">Bottle Maker</p>
                                                        <p class="info--value">{{ data.detail.bottle_maker ? data.detail.bottle_maker : 'N/A' }}</p>
                                                    </div>
                                                    <div>
                                                        <p class="info--key text-right">Tanggal Terima Data</p>
                                                        <p class="info--value text-right">{{ data.detail.oil_received_data_date ? moment(data.detail.oil_received_data_date).format("DD MMM YYYY HH:mm:ss") : 'N/A' }}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="innerBox mt-4" v-if="data.detail.customer_report_date">
                                                <p class="sub-title">Customer Report</p>

                                                <p class="info--key">Report Date</p>
                                                <p class="info--value">{{ data.detail.customer_report_date ? moment(data.detail.customer_report_date).format("DD MMM YYYY HH:mm:ss") : 'N/A' }}</p>

                                                <p class="info--key">Report Reason</p>
                                                <p class="info--value">{{ data.detail.customer_report_status ? data.detail.customer_report_status.split(",").join(", ") : 'N/A' }}</p>
                                            </div>

                                            <button
                                                type="button"
                                                class="btn btn-primary mt-4 w-100"
                                                style="height:38px; margin-bottom:0.5%; background-color: #EC1A30; border: 0"
                                                @click="resetData"
                                            >Reset Data</button>
                                            
                                        </div>
                                    </div>
                                    <div class="col-md-6" v-else>
                                        <h1 class="loading">Loading...</h1>
                                    </div>

                                    <div class="col-md-6" v-if="data.history">
                                        <time-line-chart
                                            :data="data.history"
                                            style="min-height: 600px;"
                                        ></time-line-chart>
                                    </div>
                                    <div class="col-md-6" v-else>
                                        <h1 class="loading">Loading...</h1>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
            </div>
        </div>
    </transition>
</template>

<script>
    import moment from 'moment';
    import MultiSelect from 'vue-multiselect';

    import timeLineChart from './timeLineChart';

    export default {
        data() {
            return {
                moment : moment,
                data : { 
                    detail : null,
                    history : null
                }   
            }
        },
        props : [
            'id',
        ],
        components: {
            MultiSelect,

            timeLineChart,
        },
        mounted() {
            this.fetchData();
        },
        computed : { 
            fetchHdImageIfPossible () {
                let availableImages = ['MPX1', 'MPX2', 'MPX3', 'SPX1', 'SPX2'];

                //If data is not loaded yet
                if (this.data.detail == null || this.data.detail.image == null) return '';

                let imageUrl = this.data.detail.image.replace(/ /g, "").toUpperCase();
                for (var i = 0; i < availableImages.length; i++) {
                    //If hd image is found in our assets
                    if (this.data.detail.image.includes(availableImages[i])) return require("@/assets/img/oil/" + availableImages[i] + ".png");
                }

                //If not found any image in our assets
                return this.data.detail.image;
            }
        },
        methods: {
            fetchData () {
                //Get Detail
                this.$http.get(`/api/reports/qrcode/details?id=${this.id}`)
                .then((resp)=>{
                    if (resp.data.data.length != 1) {
                        this.$swal.fire({
                            title:'Error!',
                            text:"API has changed it's content",
                            icon:"error"
                        });
                    }

                    this.data.detail = resp.data.data[0];
                })
                .catch((err)=>{console.log(err)});

                //Get History
                this.$http.get(`/api/reports/qrcode/history?id=${this.id}`)
                .then((resp)=>{
                    this.data.history = resp.data.data;
                })
                .catch((err)=>{console.log(err)});
            },
            resetData () {
                let splitQrcode = this.data.detail.qrcode.split("/");
                let qrcode = splitQrcode[splitQrcode.length-1];

                this.$swal.fire({
                    title: 'Are you sure?',
                    text: "Are you sure you want to reset this customer scan?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085D6',
                    cancelButtonColor: '#D33',
                    confirmButtonText: 'I am sure'
                }).then((result) => {
                    if (result.value) {
                        this.$http.post("/api/reports/reset-customer-scan", {"qrcode": qrcode })
                        .then((resp)=>{
                            this.$swal.fire({
                                title : "Success!",
                                icon : "success",
                                type : "success",
                                text : `Customer scan data has been successfully reset`
                            })
                        })
                        .catch((error)=>{
                            this.$swal.fire({
                                title : "Error!",
                                icon : "error",
                                type : "error",
                                text : err.response.data.message
                            })
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 1020;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body {
        margin: 0
    }

    .modal-body .moduleLine {
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a {
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover {
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox {
        border: 1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color: black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i {
        font-size: 5vh;
    }

    h3.modalHeadline {
        margin: 0 0 20px 0;
        font-weight: bold;
        text-align: center;
    }

    /* MODAL ENDS */

    .modal-body {
        max-height: 80vh;
        overflow-y: auto;
        overflow-x: auto;
    }

    .innerBox {
        padding: 0.8em 1.5em;
        border: 1px solid #EEEEEE;
        border-radius: 5px;
        background-color: white;
        box-shadow: 2px 2px 5px #E0E0E0;
    }

    .hoverable:hover {
        cursor: pointer;
    }

    .loading{
        color: #616161;
        font-size: 50px;
        text-shadow: 4px 4px 6px #BDBDBD;

        text-align: center;
        padding: 200px 0;
    }

    .sub-title {
        font-size: 20px;
        color: #3f3f3f;
        font-weight: bold;
        /* text-align: left; */
    }

    .info--key {
        font-size: 14px;
        color: #3f3f3f;
        font-weight: bold;
        text-align: left;
        margin: 0 0 5px 0;
    }

    .info--value {
        font-size: 18px;
        color: black;
        text-align: left;
        margin: 0 10px 10px 10px;
    }

    .info--image {
        position: relative;
    }

    .info--expired {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: scale(1) translate(-50%, -50%);
        /* z-index: 1; */
    }

    .info--status {
        position: absolute;
        top: -20px;
        right: -20px;
        transform: scale(1.4);
    }

    .green {
        color: green;
    }

    .orange {
        color: orange;
    }

    .red {
        color: red;
    }
</style>